
export type MessagingSendMessage201AllOfBasicInfoAllOfTwoType = typeof MessagingSendMessage201AllOfBasicInfoAllOfTwoType[keyof typeof MessagingSendMessage201AllOfBasicInfoAllOfTwoType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MessagingSendMessage201AllOfBasicInfoAllOfTwoType = {
  TEXT: 'TEXT',
  IMAGE: 'IMAGE',
  FILE: 'FILE',
  LINK: 'LINK',
} as const;
